export { default as veteranIdentification } from './veteranIdentification';
export { default as veteranDeath } from './veteranDeath';
export { default as veteranName } from './veteranName';
export { default as veteranServicePeriod } from './veteranServicePeriod';
